import React from 'react';
import type { FieldRenderProps } from 'react-final-form';

import type { IProps as TermControlProps } from '../ui/TermControl';
import { TermControl } from '../ui/TermControl';

export const FieldTermControl: React.FC<FieldRenderProps<number> & TermControlProps> = ({ input, meta, ...props }) => (
  <TermControl {...input} {...props} error={meta.touched && meta.error && String(meta.error)} />
);
